import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, message, Typography, Card } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

const AboutForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);
  const [fileList, setFileList] = useState([]); // Manage file state for preview

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);

      if (formData.image) {
        setFileList([
          {
            uid: "-1",
            name: "Uploaded Image",
            status: "done",
            url: `http://93.127.203.113:5005${formData.image}`,
          },
        ]);
      }
    }
  }, [formData]);

  const handleFileChange = ({ fileList }) => {
    setFileList(fileList);
    if (fileList.length > 0) {
      setFile(fileList[0].originFileObj);
    } else {
      setFile(null);
    }
  };

  const beforeUpload = (file) => {
    setFileList([{ uid: file.uid, name: file.name, status: "uploading" }]);
    setFile(file);
    return false;
  };

  const onFinish = async (values) => {
    const payload = new FormData();

    Object.keys(values).forEach((key) => payload.append(key, values[key]));

    if (file) {
      payload.append("image", file); // Ensure correct field name
    }

    try {
      if (formData?.id) {
        await axios.put("http://93.127.203.113:5005/about", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("About section updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/about", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("About section created successfully");
      }
      refetchData();
      closeModal();
    } catch (error) {
      message.error("Failed to save about section.");
    }
  };

  return (
    <Card style={{ padding: "20px", borderRadius: "10px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData?.id ? "Edit About Section" : "Create About Section"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Form.Item label="Title" name="title" rules={[{ required: true, message: "Please enter title" }]}>
          <Input placeholder="Enter title" />
        </Form.Item>
        <Form.Item label="Subtitle" name="subtitle" rules={[{ required: true, message: "Please enter subtitle" }]}>
          <Input placeholder="Enter subtitle" />
        </Form.Item>
        <Form.Item label="Description" name="description" rules={[{ required: true, message: "Please enter description" }]}>
          <Input.TextArea rows={4} placeholder="Enter description" />
        </Form.Item>
        <Form.Item label="Upload Image">
          <Upload
            listType="picture"
            fileList={fileList}
            maxCount={1}
            beforeUpload={beforeUpload}
            onChange={handleFileChange}
            onRemove={() => {
              setFile(null);
              setFileList([]);
            }}
          >
            <Button icon={<UploadOutlined />}>Upload Image</Button>
          </Upload>
        </Form.Item>
        <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
          Save
        </Button>
      </Form>
    </Card>
  );
};

export default AboutForm;
